export default __webpack_public_path__ + "static/media/homeEsports.ad72768b.svg";